import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion } from 'framer-motion';
import { FullBox, FullColumn } from 'seagull';
import { COBStep } from '../../ClientOnboarding.utils';
import { PreviewBanner } from '../../PreviewBanner';
import { getVendorGradientStyle } from '../ClientOnboardingV2.utils';
import { CoverPage } from '../CoverPage/CoverPage';
import { Footer } from '../OnboardingPage/Footer/Footer';
import { MobileHeader } from '../OnboardingPage/MobileHeader/MobileHeader';
import { OnboardingPage } from '../OnboardingPage/OnboardingPage';
import { animatePresenceVariants, mobileFooterVariants, mobileHeaderVariants, pageTransition, pageVariants } from './animations.mobile';
import styles from './ClientOnboardingContentMobile.module.scss';
export const ClientOnboardingContentMobile = (param)=>{
    let { relationship, currentStep, previewState, localPreviewState, dismissPreviewModal, onToggleBrandSetup, showBrandSetupButton, setCurrentStep, visitedSteps, directionRef, hasVisitedCoverPageRef, handleBack, handleNext, statement, isStatementAccepted, onStatementChange, isNextDisabled, hideNextButton, hasSignedSuccess } = param;
    const isPreview = !!previewState;
    const isCoverPage = currentStep === COBStep.welcome;
    const handleGetStarted = ()=>{
        hasVisitedCoverPageRef.current = true;
        setCurrentStep(COBStep.introduction);
    };
    const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
    const contentAreaClassName = "".concat(styles.contentArea, " ").concat(isCoverPage ? styles.contentAreaCover : hideNextButton || hasSignedSuccess ? styles.contentAreaNoFooter : styles.contentAreaOnboarding);
    const coverPageContent = /*#__PURE__*/ _jsx(CoverPage, {
        relationship: relationship,
        onGetStarted: handleGetStarted,
        isPreview: isPreview,
        showRecipientToast: !hasVisitedCoverPageRef.current && !previewState
    });
    const onboardingPageContent = /*#__PURE__*/ _jsx(OnboardingPage, {
        relationship: relationship,
        currentStep: currentStep,
        direction: directionRef.current,
        onStepClick: setCurrentStep,
        onBack: handleBack,
        onNext: handleNext,
        visitedSteps: visitedSteps,
        statement: statement,
        isStatementAccepted: isStatementAccepted,
        onStatementChange: onStatementChange,
        isNextDisabled: isNextDisabled,
        hideNextButton: hideNextButton,
        hasSignedSuccess: hasSignedSuccess
    });
    return /*#__PURE__*/ _jsxs(FullColumn, {
        className: styles.container,
        children: [
            isPreview && /*#__PURE__*/ _jsx(PreviewBanner, {
                previewState: previewState,
                localPreviewState: localPreviewState,
                onToggleBrandSetup: onToggleBrandSetup,
                onDismiss: dismissPreviewModal,
                showBrandSetupButton: showBrandSetupButton
            }),
            /*#__PURE__*/ _jsxs(FullBox, {
                flexDirection: "column",
                className: styles.contentBox,
                style: gradientStyle,
                children: [
                    /*#__PURE__*/ _jsx(AnimatePresence, {
                        children: !isCoverPage && !hasSignedSuccess && /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({
                            className: styles.headerWrapper,
                            variants: mobileHeaderVariants
                        }, animatePresenceVariants), {
                            children: /*#__PURE__*/ _jsx(MobileHeader, {
                                relationship: relationship,
                                showBack: true,
                                onBack: handleBack
                            })
                        }), "mobile-header")
                    }),
                    /*#__PURE__*/ _jsx(AnimatePresence, {
                        mode: "wait",
                        initial: false,
                        custom: isCoverPage,
                        children: /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({
                            custom: isCoverPage,
                            variants: pageVariants,
                            transition: pageTransition
                        }, animatePresenceVariants), {
                            className: contentAreaClassName,
                            children: isCoverPage ? coverPageContent : onboardingPageContent
                        }), isCoverPage ? 'cover' : 'inner')
                    }),
                    /*#__PURE__*/ _jsx(AnimatePresence, {
                        children: !isCoverPage && !hideNextButton && !hasSignedSuccess && /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({
                            className: styles.footerWrapper,
                            variants: mobileFooterVariants
                        }, animatePresenceVariants), {
                            children: /*#__PURE__*/ _jsx(Footer, {
                                currentStep: currentStep,
                                relationship: relationship,
                                onNext: handleNext,
                                isNextDisabled: isNextDisabled
                            })
                        }), "mobile-footer")
                    })
                ]
            })
        ]
    });
};
